<template>
    <modal size="lg" @close="reset(); $emit('close')" :height-max="true" ref="modal" :is-closeable="isCloseable" :autoshow="true">
        <template v-slot:title>
            <h3 class="modal-title">Edit Deferred Compensation Plan</h3>
        </template>

        <slot>
            <div class="mb-2">
                <div class="p-1 unpad-x bg-150 rounded">
                    <div><span class="text-muted">Company: </span>{{ company.name }}</div>
                    <div><span class="text-muted">Deferred Compensation Plan: </span>{{ plan.display_name }}</div>
                </div>
            </div>

            <plan-form
                ref="planForm"
                :initial-value="formData"
                :show-plan-number="true"
            />

        </slot>

        <template v-slot:footer>
            <form-errors :errors="formErrors"/>

            <button-row stacked>
                <button type="button" class="btn btn-outline-primary" @click.prevent="close()">
                    Cancel
                </button>

                <button type="button" class="btn btn-primary" @click.prevent="onSubmit()">
                    Save
                </button>
            </button-row>
        </template>
    </modal>
</template>

<script>
import FormMixin from '@/mixins/Form'
import ModalMixin from '@/mixins/ModalMixin'
import PlanForm from './PlanForm'

export default {
    props: ['client', 'plan', ],
    mixins: [FormMixin, ModalMixin],
    components: {PlanForm, },
    emits: ['updated', 'close', ],
    data() {
        return {
            formData: this.makeFormData(),
        }
    },
    computed: {
        company() {
            return this.client.companies.find(c => c.id == this.plan.company_id)
        },
    },
    methods: {
        makeFormData() {
            return {
                starts_on: this.plan.starts_on,
                plan_type: this.plan.plan_type ? this.plan.plan_type : '',
                provider_name: this.plan.provider_name ? this.plan.provider_name : '',
                plan_number: this.plan.plan_number ? this.plan.plan_number : '',
                money_manager: this.plan.money_manager ? this.plan.money_manager : '',
                routing_number: this.plan.routing_number ? this.plan.routing_number : '',
                account_number: '',
                account_number_last_4: this.plan.account_number_last_4 ? this.plan.account_number_last_4 : '',
            }
        },
        onSubmit() {
            if (!this.$refs.planForm.validate()) {
                this.formErrors = this.$refs.planForm.formErrors
                return
            }

            const data = this.$refs.planForm.getFormData()

            this.$store.dispatch('START_LOADING')
            const url = `/clients/${this.client.id}/settings/deferred-comp-plans/${this.plan.id}`
            this.$api.put(url, data).then(resp => {
                this.$store.dispatch('STOP_LOADING')
                this.$bus.showInfo(`Successfully saved deferred compensation plan details.`)
                this.$emit('updated', resp)
                this.close()
            }).catch((errors) => {
                this.$store.dispatch('STOP_LOADING')
                this.$refs.planForm.setErrors(errors)
                this.formErrors = (errors.__all__ || [])
                this.$bus.showError(errors.__all__)
            })
        }
    }
}
</script>
